import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import LoginForm from './loginForm';
import { login } from '../../actions/authentication';
import CardFormContainer from '../../containers/card-form-container/cardFormContainer';
import { INSPECTORS_ROUTE } from '../../routing/paths';

const LoginScreen = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const isLogging = useSelector( ( state ) => state.authentication.isLogging );
	const handleSubmit = ( form ) => dispatch( login( form, () => history.push( INSPECTORS_ROUTE ) ) );

	return (
		<CardFormContainer title="Iniciar sesión">
			<LoginForm onSubmit={handleSubmit} isLoading={isLogging} />
		</CardFormContainer>
	);
};

export default LoginScreen;
